import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/**
 * Executes a callback function on each element of an array sequentially, ensuring that each
 * callback completes before moving to the next one. Unlike parallel execution, this function
 * ensures that async operations occur one after the other (in sequence).
 *
 * We are suppressing https://eslint.org/docs/latest/rules/no-await-in-loop
 *
 * @param {Array} arr - The array of elements to process.
 * @param {Function} callback - An async callback function that will be called with each element.
 *  The callback receives three arguments: the current element, its index, and the entire array.
 * @returns {Promise<Array<{result: any, error: boolean}>>} - A promise that resolves to an array
 *  of results where each entry contains the result of the callback or an error. Each entry is an
 *  object with the properties:
 *   - `result`: the result of the callback, or the error object if an error occurred.
 *   - `error`: a boolean indicating if an error occurred for that element.
 */
export function asyncSequentialMap(_x, _x2) {
  return _asyncSequentialMap.apply(this, arguments);
}
function _asyncSequentialMap() {
  _asyncSequentialMap = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(arr, callback) {
    var results, i, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          results = [];
          i = 0;
        case 2:
          if (!(i < arr.length)) {
            _context.next = 16;
            break;
          }
          _context.prev = 3;
          _context.next = 6;
          return callback(arr[i], i, arr);
        case 6:
          result = _context.sent;
          results.push({
            result: result,
            error: false
          });
          _context.next = 13;
          break;
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](3);
          results.push({
            result: _context.t0,
            error: true
          });
        case 13:
          i += 1;
          _context.next = 2;
          break;
        case 16:
          return _context.abrupt("return", results);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _asyncSequentialMap.apply(this, arguments);
}